var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhiteboardAdd = function SvgWhiteboardAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2z",
    style: {
      fill: "#8bacff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "whiteboard_add_svg__st1",
    d: "M14.4 7.5H9.9c-.3 0-.6-.3-.6-.6V4.7c0-.3.3-.6.6-.6h4.5c.3 0 .6.3.6.6v2.1c0 .4-.2.7-.6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "whiteboard_add_svg__st1",
    d: "M18.1 5.8h-2.3v1.1c0 .7-.6 1.4-1.4 1.4H9.9c-.7 0-1.4-.6-1.4-1.4V5.8H5.9c-.6 0-1.2.5-1.2 1.2v11.1c0 .7.5 1.2 1.2 1.2H18c.7 0 1.2-.5 1.2-1.2V7c.1-.7-.5-1.2-1.1-1.2zm-3.6 7.9h-1.7v1.7c0 .5-.4.8-.8.8s-.8-.4-.8-.8v-1.7H9.5c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h1.7v-1.7c0-.5.4-.8.8-.8s.8.4.8.8V12h1.7c.5 0 .8.4.8.8 0 .5-.4.9-.8.9z"
  })));
};
export default SvgWhiteboardAdd;